import styled from 'styled-components';
import { inboxSkeletonSurface } from '../pages/canvas/components/inbox/skeleton/inboxSkeletonStyles';

/**
 * A placeholder block with the inbox's soft shimmer, sized by the caller. Laid out in
 * the same grid as the content it stands in for, so nothing jumps when that arrives.
 */
const SkeletonBone = styled.span<{ $w?: string; $h?: string; $radius?: string }>`
  display: block;
  flex-shrink: 0;
  width: ${({ $w }) => $w ?? '100%'};
  height: ${({ $h }) => $h ?? '12px'};
  border-radius: ${({ $radius }) => $radius ?? '6px'};
  ${inboxSkeletonSurface}
`;

/** Stacked bones with room between them, e.g. a title over its subtitle. */
export const SkeletonStack = styled.span<{ $gap?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => $gap ?? '6px'};
  min-width: 0;
`;

export default SkeletonBone;
